export default __webpack_public_path__ + "static/media/mongo.94082411.png";